export default __webpack_public_path__ + "static/media/bt-1.0c38eddd.png";